import React, { useMemo } from "react";

import Form from "antd/es/form";
import { defineMessages, useIntl } from "react-intl";

import RadioGroup from "@app/component/input/RadioGroup";
import { DateSubRange } from "@app/enum/dashboard/dateRanges";
import ViewMode, { getViewModeDisplayName } from "@app/enum/dashboard/ViewMode";

const messages = defineMessages({
  defaultView: {
    id: "dashboard.editModal.criteria.outOfFrequency.defaultView",
    defaultMessage: "Default View",
    description:
      "Title of the Default View field in preferences form in Edit Out Of Frequency Modal on Dashboard",
  },
});

interface Props {}

const PreferencesFormComponent: React.FC<Props> = () => {
  const intl = useIntl();

  const modeOptions = useMemo(
    () =>
      Object.values(ViewMode).map((mode) => ({
        label: getViewModeDisplayName(intl, mode),
        value: mode,
      })),
    [intl]
  );

  return (
    <div>
      <Form.Item
        label={intl.formatMessage(messages.defaultView)}
        name={["preferences", "defaultMode"]}
      >
        <RadioGroup<DateSubRange> options={modeOptions} vertical />
      </Form.Item>
    </div>
  );
};

export default PreferencesFormComponent;
